/** Semantic tokens — use for inline styles that must track light/dark. */
export const theme = {
  bg: 'var(--bg)',
  bg2: 'var(--bg2)',
  bg3: 'var(--bg3)',
  card: 'var(--card)',
  card2: 'var(--card2)',
  border: 'var(--border)',
  border2: 'var(--border2)',
  text: 'var(--text)',
  textSecondary: 'var(--muted)',
  textMuted: 'var(--muted)',
  primary: '#BE5103',
  secondary: '#FFCE1B',
  accent: '#069494',
  success: '#069494',
  warning: '#FFCE1B',
  danger: '#B7410E',
} as const;

export const categoryColors: Record<string, string> = {
  'Core AI Intelligence': '#BE5103',
  Omnipresence: '#069494',
  'Content & Social': '#FFCE1B',
  'Paid Ads & SEO': '#B7410E',
  'Engagement & Network': '#069494',
  'Technical SEO': '#E8721A',
  'Game Changers': '#B7410E',
  'Revenue Multipliers': '#FFCE1B',
  'Trust & Credibility': '#069494',
  'Operations & Control': '#BE5103',
  'GEO & AI Visibility': '#069494',
};

export function colorForCategory(cat: string): string {
  return categoryColors[cat] ?? '#BE5103';
}
